// extracted by mini-css-extract-plugin
module.exports = {"container":"Sharing_container__26icX","title":"Sharing_title__x-R5a","list":"Sharing_list__333R5"};